<script lang="ts">
  import Button from "../atoms/Button.svelte";
  import type { SignStartResult } from "../../helpers/types";
  import Loader from "../atoms/Loader.svelte";
  import BankIdIcon from "../BankIdIcon.svelte";
  import { getBankIdUrl } from "../../helpers/helperMethods";

  interface Props {
    isLoading: boolean;
    signData: SignStartResult | undefined;
    signWithQRCode: boolean;
    cancelSigning: () => void;
    changeSignDevice: () => void;
  }

  let {
    isLoading,
    signData,
    signWithQRCode = $bindable(),
    cancelSigning,
    changeSignDevice,
  }: Props = $props();
</script>

<div class="flex flex-col">
  <span class="text-black text-lg leading-6 mx-auto font-bold"
    >{signWithQRCode ? "BankID med QR-kod" : "BankID på denna enhet"}</span
  >
  {#if isLoading}
    <div class="h-60 flex">
      <div class="m-auto">
        <Loader variant="purple" size="big" />
      </div>
    </div>
  {:else if signData && signWithQRCode && signData.base64QRCode}
    <div class="mx-auto mt-4 flex flex-col">
      <img
        class="mx-auto"
        height="246"
        width="246"
        src={"data:image/png;base64, " + signData.base64QRCode}
        alt="QR Code"
      />
      <span class="text-Neutral900 text-center text-L mt-4 mx-10"
        >Öppna din BankID-app. Tryck på “scanna QR-kod” och rikta kameran mot QR-koden ovan. Följ
        instruktionerna i appen för att logga in.</span
      >
    </div>
  {:else if signData && !signWithQRCode && signData.BankIdAutoStartToken}
    <div class="mx-16 flex flex-col">
      <div class="py-4 mx-auto">
        <BankIdIcon width={54} height={50} />
      </div>
      <Button href={getBankIdUrl(signData.BankIdAutoStartToken)} class="mt-4">Öppna BankID</Button>
    </div>
  {/if}
</div>
<div class="mt-4 flex flex-col space-y-4">
  <Button disabled={isLoading} class="w-full" variant="ghost" onClick={changeSignDevice}
    >{signWithQRCode
      ? "Använd BankID på den här enheten"
      : "Använd BankID på en annan enhet"}</Button
  >
  <Button disabled={isLoading} class="w-full" variant="ghost" onClick={cancelSigning}>Avbryt</Button
  >
</div>
